import { FC } from 'react';
import { Checkbox as MuiCheckbox, CheckboxProps as MuiCheckboxProps, Stack, SxProps, Theme, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface CheckBoxProps extends MuiCheckboxProps {
  label?: string;
  isTrueFalse?: boolean;
  sx?: SxProps<Theme>
}

const CheckBox: FC<CheckBoxProps> = ({
  name,
  label,
  isTrueFalse = false,
  defaultValue, sx = [],
  ...props
}) => {
  const { control, setValue } = useFormContext();

  return (
    <Controller
      name={name ? name : ''}
      defaultValue={isTrueFalse ? (defaultValue === 1 ? true : false) : defaultValue}
      control={control}
      render={({
        field,
        field: { onChange, value },
        fieldState
      }) => (
        <Stack direction="column">
          <Stack
            direction="row"
            alignItems={"center"}
            sx={{
              cursor: 'pointer',
              width: 'fit-content'
            }}
            onClick={() => setValue(`${name}`, !value)}>
            <MuiCheckbox
              {...field}
              sx={[
                {
                  backgroundColor: 'white',
                  "&.Mui-checked": {
                    color: "#3D4449"
                  }
                },
                ...(Array.isArray(sx) ? sx : [sx])
              ]}
              value={value}
              checked={!!value}
              {...props}
              onChange={(event) => {
                onChange(event);
                if (props.onChange)
                  props.onChange(event, value);
              }}
            />
            {label &&
              <Typography>{label}</Typography>
            }
          </Stack>
          <Typography variant="errorFont">
            {fieldState.error?.message}
          </Typography>
        </Stack>
      )}
    />
  );
}

export default CheckBox;
